import { render } from "./RegistrationFormSettingsModal.vue?vue&type=template&id=a22748d8&scoped=true"
import script from "./RegistrationFormSettingsModal.vue?vue&type=script&lang=js"
export * from "./RegistrationFormSettingsModal.vue?vue&type=script&lang=js"

import "./RegistrationFormSettingsModal.vue?vue&type=style&index=0&id=a22748d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a22748d8"]])

export default __exports__